import SiparisList from "./Modules/Siparisler/SiparisList";

export default {
  namespaced: true,
  modules: {
    SiparisList: SiparisList,
  },
};
